import React, { useEffect, useState } from "react";
import LedgersRepository from "../../Repository/LedgersRepository";
import { Dialog, DialogContent, Paper, Table, TableBody } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import moment from "moment";
import Loader from "../components/Loader";
import { useSelector } from "react-redux";

const LedgerHistory = ({ open, onClose, sr }) => {
  const { selected, type } = useSelector((state) => state.ledger);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getSummary();
  }, []);

  const getSummary = async () => {
    setLoading(true);
    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "getLedgerSummary",
        data: {
          ledger_id: selected._id,
        },
      },
    });
    setLoading(false);
    setHistory(data.response.data.summary);
  };
  return (
    <Dialog title="History" open={open} onClose={onClose}>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 550 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell>Date </TableCell>
                <TableCell>Time </TableCell>
                <TableCell>History Logs </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history
                ?.filter((item) => item.changedSrNum == sr)
                .map((historyItem, index) => {
                  let old;
                  let newLed;
                  if (historyItem?.old_ledger.length != 0) {
                    old = historyItem?.old_ledger[0].depositedAmount;
                  }
                  if (historyItem?.new_ledger.length != 0) {
                    newLed = historyItem?.new_ledger[0].depositedAmount;
                  }
                  return (
                    <TableRow key={index}>
                      <TableCell component="th">
                        {moment
                          .unix(historyItem.created_at)
                          .format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell component="th">
                        {moment.unix(historyItem.created_at).format("hh:mm A")}
                      </TableCell>
                      {old != newLed && (
                        <TableCell component="th">
                          You have {type == "purchase" ? "paid" : "received"}{" "}
                          {parseInt(old - newLed)}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <Loader loading={loading} />
      </DialogContent>
    </Dialog>
  );
};

export default LedgerHistory;
